import * as React from 'react'
import Select from 'react-select'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { FormError } from '../../../../../components/FormError'
import { parseErrorMsg } from '../../../../../utilities/helpers'
import { LowStockNotificationAPI } from '@getgreenline/inventory'
import SaveButton from './SaveButton'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
  onSubmit: () => void
  onClose: () => void
}

interface State {
  locationId?: number
  isSaving: boolean
  errorMessage?: string
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class AddAlertModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
    }
  }

  save() {
    const user = this.props.currentUserStore?.currentUser
    const company = this.props.currentCompanyStore?.company
    const locationId = this.state.locationId

    if (!user || !company || !locationId) {
      return
    }

    this.setState({ isSaving: true })

    LowStockNotificationAPI.addLowStockNotification(company.id, {
      userId: user.id,
      companyId: company.id,
      locationId,
    })
      .then(() => {
        this.props.onSubmit()
      })
      .catch((error) => {
        this.setState({ isSaving: false, errorMessage: parseErrorMsg(error) })
      })
  }

  render() {
    const locations = this.props.currentCompanyStore?.locations || []

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()}>
        <ModalHeader toggle={() => this.props.onClose()}>Add inventory alert</ModalHeader>
        <ModalBody>
          <div className='form-group'>
            <label>Select location</label>
            <Select
              placeholder='Select location'
              value={this.state.locationId}
              clearable={false}
              options={locations.map((l) => {
                return {
                  label: l.name,
                  value: l.id,
                }
              })}
              onChange={(option: { label: string; value: number }) => {
                this.setState({ locationId: option.value })
              }}
            />
          </div>

          <br />

          <div>
            <SaveButton
              isSaving={this.state.isSaving}
              locationId={this.state.locationId}
              onClick={() => this.save()}
            />
          </div>
          <FormError message={this.state.errorMessage} />
        </ModalBody>
      </Modal>
    )
  }
}
